/**
 *
 @component 个人中心/我的方案/项目管理/协作项目详情/施工进度计划tab
 *
 **/
import {
    Button,
    Space,
    Menu,
    Dropdown,
    Empty,
    Form,
    Input,
    Spin,
    Badge,
    Modal,
    message,
    Tooltip,
} from 'antd';
import './ScheduleProgressTab.scss';
import NewPlan from './NewPlan';
import SelectTemplate from './SelectTemplate';
import ProgressGantt from '@/components/UserCenter1.4/ProgressGantt';
import BaseModal from '&/components/BaseModal';
import DetailDrawer from './DetailDrawer/index.js';
import {
    queryPlanList,
    queryMembers,
    publishPlan,
    saveTemplate,
    clearPlans,
    exportPlans,
} from '@/api/personCenter/projectSpace1.4';
import { useHistory, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { PLAN_STATUS } from '&/utils/baseMacro';
import usePermission from '&/utils/customHooks/usePermission';
import CheckReportDrawer from './CheckReportDrawer/index.js';
import { useRef } from 'react';

const { UNCONFIRM } = PLAN_STATUS;

function ScheduleProgressTab(props) {
    const location = useLocation();
    const history = useHistory();
    const SEARCH = new URLSearchParams(location.search);
    const projectId = SEARCH.get('id');
    const openPlanId = SEARCH.get('planId');
    const isProjectCheck = SEARCH.get('projectCheck');
    const planCheckId = SEARCH.get('planCheckId');
    const [permission, currentRole] = usePermission(projectId);

    useEffect(() => {
        if (openPlanId) {
            activeId.current = openPlanId;
            setVisibleDrawer(true);
        }
        if (isProjectCheck) {
            viewReport();
        }
        if (planCheckId) viewReport();
    }, []);

    useEffect(() => {
        queryList();
    }, []);

    const [disabled, setDisabled] = useState(false);
    const onPublish = () => {
        setDisabled(true);
        publishPlan({ projectId })
            .then(({ msg }) => {
                queryList();
                message.success(msg);
            })
            .finally(() => {
                setDisabled(false);
            });
    };

    const [tasks, setTasks] = useState([]);
    const taskList = useRef([]); //  用来清空计划  因为tasks放在甘特图中疑似被污染
    const [statistics, setStatistics] = useState({});
    const [projectInfo, setInfo] = useState({});
    const [listLoading, setListLoading] = useState(false);
    const projectName = useRef();

    function html2Escape(sHtml) {
        return sHtml.replace(/[<>&"]/g, function (c) {
            return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
        });
    }

    function tansformDate(date, type) {
        return dayjs(date || undefined)
            [type]('day')
            .toDate();
    }
    const minmaxDate = useRef({});
    const key = useRef(0);

    function queryList() {
        setListLoading(true);
        key.current++;
        queryPlanList({ projectId })
            .then(({ data }) => {
                taskList.current = data.plan.map(item => ({
                    ...item,
                    dateRange: `${dayjs(item.timeAt).format(
                        'MM-DD'
                    )} ${intl.get('base.to')} ${dayjs(item.timeEnd).format(
                        'MM-DD'
                    )}`,
                    type: 'task', // project   相当于一个文件  采集底下任务的进度来自动有
                    name: html2Escape(item.name),
                    start_date: tansformDate(
                        ['0', '1'].includes(item.status)
                            ? item.timeAt
                            : item.finishAt,
                        'startOf'
                    ),
                    end_date: tansformDate(
                        ['0', '1'].includes(item.status)
                            ? item.timeEnd
                            : item.finishEnd,
                        'endOf'
                    ),
                }));
                minmaxDate.current = data.statistics.dayMinMax;
                setTasks(taskList.current);
                setStatistics(data.statistics ?? {});
                setInfo(data.project);
                projectName.current = data.project.projectName;
            })
            .finally(() => {
                setListLoading(false);
            });
    }

    const [templateVisible, setTemplateVisible] = useState();
    function selectTemplate() {
        setTemplateVisible(true);
    }

    const [planVisible, setPlanVisible] = useState(false);
    function createPlan(id) {
        selectId.current = id;
        setTemplateVisible(false);
        setPlanVisible(true);
        getMembers();
    }

    const [members, setMembers] = useState([]);

    async function getMembers() {
        const { data } = await queryMembers({ projectId });
        setMembers(data ?? []);
    }

    const handleMenuClick = ({ key }) => {
        [saveAsTemplate, onExport, removeAllPlans][key]();
    };

    // 导出项目的施工计划
    function onExport() {
        if (!permission.includes('exportExcel')) return;
        const hideMsg = message.loading(intl.get('base.uploading'), 0);
        exportPlans({ projectId })
            .then(async res => {
                if (res.headers['content-type'].includes('application/json')) {
                    const jsonRes = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = e => {
                            resolve(JSON.parse(e.target.result));
                        };
                        reader.readAsText(res.data);
                    });
                    return Promise.reject(jsonRes);
                } else {
                    const blob = new Blob([res.data]);
                    let obkectUrl = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = obkectUrl;
                    a.download = intl.get('projectSpace.excelName', {
                        name: projectName.current,
                    });
                    a.click();
                    window.URL.revokeObjectURL(blob);
                }
            })
            .catch(err => {
                message.warning(err.msg);
            })
            .finally(hideMsg);
    }

    function removeAllPlans(planId = []) {
        if (currentRole !== 8) return;
        const modal = Modal.confirm({
            content: planId.length
                ? intl.get('projectSpace.confirmDel')
                : intl.get('projectSpace.confirmClear'),
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            okButtonProps: { loading: false },
            centered: true,
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await clearPlans({
                        projectId,
                        planId,
                    });
                    onCloseDrawer(); // 防止详情未关闭
                    queryList();
                    message.success(msg);
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    }

    const [visibleDrawer, setVisibleDrawer] = useState(false);

    const STATUS_DICT = [
        {
            name: intl.get('projectSpace.unstart'),
            icon: 'icon-remove',
            type: 'default',
        },
        {
            name: intl.get('projectSpace.unconfirm'),
            icon: 'icon-clock',
            type: 'danger',
        },
        {
            name: intl.get('projectSpace.underway'),
            icon: 'icon-clock',
            type: 'warning',
        },
        {
            name: intl.get('projectSpace.unaccepted'),
            icon: 'icon-clock',
            type: 'danger',
        },
        {
            name: intl.get('projectSpace.pass'),
            type: 'success',
            icon: 'icon-Confirm',
        },
        {
            name: intl.get('projectSpace.notPass'),
            icon: 'icon-info-circle2',
            type: 'danger',
        },
        {
            name: intl.get('projectSpace.postponed'), //  只在查询的时候使用
        },
    ];

    const activeId = useRef(); // 详情打开的ID
    const selectId = useRef(); // 准备插入位置的ID
    const rightClickId = useRef(); // 右键触发的ID
    const [execute, setExecute] = useState(-1); //  是否为右键计划的创建者
    const ganttRef = useRef();
    const STATIC_DATA = {
        unSelect: !visibleDrawer,
        currentRole,
        ref: ganttRef,
        onChange: queryList,
        columns: [
            {
                name: 'name',
                label: intl.get('projectSpace.project'),
                resize: true,
                width: '*',
                // min_width: 150,
                onrender: item => {
                    return (
                        <>
                            <div className="text-no-wrap">{item.name}</div>
                            {item.isEntry > 0 && (
                                <Tooltip
                                    key={item.id}
                                    title={intl.get(
                                        'projectSpace.hasAdditional'
                                    )}
                                    trigger="hover">
                                    <div className="has-additional">
                                        <div className="additional-icon">¥</div>
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    );
                },
            },
            {
                name: 'dateRange',
                label: intl.get('projectSpace.planTime'),
                align: 'center',
                resize: true,
                width: 120,
            },
            {
                name: 'times',
                label: intl.get('projectSpace.times'),
                align: 'center',
                resize: true,
                width: 60,
            },
            {
                name: 'status',
                label: intl.get('projectSpace.status'),
                align: 'center',
                resize: true,
                width: 100,
                /* template: e => {
                    return STATUS_DICT[e.status].name;
                },  */ // 两个 参数类似  但是多了个node， 且2可以返回 react  #ff4d4f
                onrender: item => {
                    return item.isDelay === '1' && UNCONFIRM !== item.status ? (
                        <span className="status--danger">
                            <i className="filled icon-info-circle2"></i>
                            {intl.get('projectSpace.postponed')}
                        </span>
                    ) : (
                        <span
                            className={`status--${
                                STATUS_DICT[item.status].type
                            }`}>
                            <i
                                className={`filled ${
                                    STATUS_DICT[item.status].icon
                                }`}></i>
                            {STATUS_DICT[item.status].name}
                        </span>
                    );
                },
            },
        ],
        tasks,
        permission,
        statusDict: STATUS_DICT,
        onClickTask: showDetail,
        onTaskSelected: id => {
            selectId.current = id;
        },
        contextMenu: (
            <Menu>
                <Menu.Item
                    disabled={!permission.includes('addPlan')}
                    onClick={() => createPlan(rightClickId.current)}>
                    {intl.get('projectSpace.newPlan')}
                </Menu.Item>
                <Menu.Item onClick={() => showDetail(rightClickId.current)}>
                    {intl.get('base.viewDetail')}
                </Menu.Item>
                <Menu.Item
                    disabled={currentRole !== 8 && execute === 0}
                    onClick={() => removeAllPlans([rightClickId.current])}>
                    {intl.get('projectSpace.delPlan')}
                </Menu.Item>
            </Menu>
        ),
        onRightClick(task) {
            rightClickId.current = task.id;
            setExecute(task.execute);
        },
        ...minmaxDate.current,
    };

    function showDetail(id) {
        activeId.current = id;
        setVisibleDrawer(true);
    }

    function onCloseDrawer() {
        setVisibleDrawer(false);
    }

    const [reporVisible, setReporVisible] = useState(false);
    function viewReport() {
        setReporVisible(true);
    }
    const onCloseRepor = () => {
        if (isProjectCheck || planCheckId) {
            location.search = '?id=' + SEARCH.get('id');
            history.replace(location.search);
        }
        setReporVisible(false);
    };

    const { Item } = Form;

    const contentEl = (
        <>
            <div className="progress-header">
                <Space size={10}>
                    <Item label={intl.get('projectSpace.progress')}>
                        {statistics.isFinish}%
                    </Item>
                    <Item label={intl.get('projectSpace.postponedDays')}>
                        <span className="orange-color">{statistics.duty}</span>
                    </Item>
                    <Item label={intl.get('projectSpace.reciprocal')}>
                        {statistics.reciprocal}天
                    </Item>

                    <Item
                        className="pointer"
                        onClick={viewReport}
                        label={intl.get('projectSpace.explain')}>
                        {statistics.planCheckNum > 0 ? (
                            <Badge
                                dot
                                size="small"
                                offset={[1, 3]}
                                color="#E84F47">
                                {tasks.length}
                            </Badge>
                        ) : (
                            tasks.length
                        )}
                    </Item>
                </Space>
                {projectInfo.status === '5' && (
                    <Button
                        disabled={
                            disabled || !permission.includes('announcePlan')
                        }
                        onClick={
                            permission.includes('announcePlan')
                                ? onPublish
                                : undefined
                        }
                        type="primary"
                        className="publish-btn">
                        <span className="publish-btn__text">
                            {intl.get('projectSpace.publish')}
                        </span>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.8508 8.14997C15.8411 7.74957 15.6204 7.38416 15.2705 7.18925L1.61564 0.361821C1.20852 0.156762 0.714432 0.250779 0.411082 0.591028C0.091923 0.906332 0.0257905 1.39732 0.25015 1.78583L3.59072 8.14022L0.211137 14.5141C0.0205314 14.9036 0.0968003 15.371 0.401329 15.6797C0.720838 15.9798 1.18703 16.0639 1.59125 15.8942L15.2754 9.03754C15.6175 8.87191 15.8392 8.5299 15.8508 8.14997Z"
                                fill="white"
                            />
                        </svg>
                    </Button>
                )}
            </div>
            <div className="progress-gantt-wrap">
                <ProgressGantt
                    {...STATIC_DATA}
                    pID={projectId}
                    isPublish={projectInfo.status < 5}
                />
            </div>
        </>
    );

    const emptyEl = (
        <Empty
            image={
                require('@/assets/img/userCenter1.4/emptyydata-object.png')
                    .default
            }
            imageStyle={{
                height: '11rem',
                marginTop: '8%',
            }}
            description={
                <>
                    <div className="message">
                        {intl.get('projectSpace.noHavePlan')}
                    </div>
                    <Space size={20} className="buy-link">
                        <div
                            className={`${
                                !permission.includes('selectTemplate') &&
                                'type--disabled'
                            }`}
                            onClick={
                                permission.includes('selectTemplate')
                                    ? selectTemplate
                                    : undefined
                            }>
                            {intl.get('projectSpace.selectTemplate')}
                        </div>
                        <div
                            className={`${
                                !permission.includes('addPlan') &&
                                'type--disabled'
                            }`}
                            onClick={() =>
                                permission.includes('addPlan') && createPlan()
                            }>
                            {intl.get('projectSpace.newPlan')}
                        </div>
                    </Space>
                </>
            }></Empty>
    );

    const [saveVisible, setSaveVisible] = useState();

    //  打开"保存模板"弹窗
    function saveAsTemplate() {
        if (!permission.includes('saveTemplate')) return;
        setSaveVisible(true);
    }
    const [saveForm] = Form.useForm();
    const [saveLoading, setSaveLoading] = useState(false);

    //  关闭"保存模板"弹窗
    const closeSaveModal = () => {
        setSaveVisible(false);
        saveForm.resetFields();
    };

    // 保存模板Form 提交前验证
    const onSubmit = () => {
        saveForm.submit();
    };

    // 保存模板Form 提交
    const onFinish = values => {
        setSaveLoading(true);
        saveTemplate(values)
            .then(({ msg }) => {
                message.success(intl.get('projectSpace.templateSaved'));
                closeSaveModal();
            })
            .finally(() => {
                setSaveLoading(false);
            });
    };

    return (
        <Spin style={{ height: '100%' }} size="large" spinning={listLoading}>
            <div className="schedule-progress video-wrap">
                <Space className="top-right">
                    <Button
                        type="primary"
                        disabled={!permission.includes('selectTemplate')}
                        onClick={
                            permission.includes('selectTemplate')
                                ? selectTemplate
                                : undefined
                        }>
                        {intl.get('projectSpace.selectTemplate')}
                    </Button>
                    <Button
                        type="primary"
                        disabled={!permission.includes('addPlan')}
                        onClick={() =>
                            permission.includes('addPlan') && createPlan()
                        }>
                        {intl.get('projectSpace.newPlan')}
                    </Button>

                    <Dropdown
                        overlay={
                            <Menu onClick={handleMenuClick}>
                                <Menu.Item
                                    disabled={
                                        !tasks.length ||
                                        !permission.includes('saveTemplate')
                                    }
                                    key={0}>
                                    {intl.get('projectSpace.saveAsTemplate')}
                                </Menu.Item>
                                <Menu.Item
                                    disabled={
                                        !tasks.length ||
                                        !permission.includes('exportExcel')
                                    }
                                    key={1}>
                                    {intl.get('projectSpace.export')}
                                </Menu.Item>
                                <Menu.Item
                                    disabled={
                                        !tasks.length || currentRole !== 8
                                    }
                                    key={2}>
                                    {intl.get('projectSpace.clearPlan')}
                                </Menu.Item>
                            </Menu>
                        }
                        placement="bottomRight">
                        <Button>
                            <i className="filled icon-more-h" />
                        </Button>
                    </Dropdown>
                </Space>
                {!!tasks.length ? contentEl : emptyEl}
                <SelectTemplate
                    createPlan={() => createPlan()}
                    projectId={projectId}
                    visible={templateVisible}
                    refresh={queryList}
                    setVisible={setTemplateVisible}
                />
                <NewPlan
                    pID={projectId}
                    members={members}
                    targetPlanId={selectId.current}
                    onSuccess={queryList}
                    visible={planVisible}
                    setVisible={setPlanVisible}
                    isNeed={projectInfo.status !== '5'}
                />
                <DetailDrawer
                    key={key.current}
                    visible={visibleDrawer}
                    planId={activeId.current}
                    statusDict={STATUS_DICT}
                    projectId={projectId}
                    members={members}
                    onRefresh={queryList}
                    onClose={onCloseDrawer}
                    permission={permission}
                    currentRole={currentRole}
                />
                <CheckReportDrawer
                    visible={reporVisible}
                    projectId={projectId}
                    onClose={onCloseRepor}
                    isProjectCheck={isProjectCheck}
                />

                <BaseModal
                    width="25.75rem"
                    visible={saveVisible}
                    title={intl.get('projectSpace.saveAsTemplate')}
                    footer={
                        <Space>
                            <Button onClick={closeSaveModal}>
                                {intl.get('base.cancel')}
                            </Button>
                            <Button
                                type="primary"
                                onClick={onSubmit}
                                loading={saveLoading}>
                                {intl.get('base.confirm')}
                            </Button>
                        </Space>
                    }
                    onCancel={closeSaveModal}>
                    <div className="form-group save-as-template">
                        <Form
                            labelCol={{ span: 6 }}
                            form={saveForm}
                            onFinish={onFinish}>
                            <Item
                                required
                                label={intl.get(
                                    'templateSettings.templateName'
                                )}
                                name="templateName"
                                rules={[
                                    { required: true },
                                    {
                                        validator: async (rule, value) => {
                                            if (!value) return;
                                            const val = value.replace(
                                                /[\u4e00-\u9fa5]/g,
                                                'aa'
                                            );
                                            if (val.length < 31) {
                                                return Promise.resolve();
                                            }
                                            throw new Error(
                                                intl.get('projectSpace.limit30')
                                            );
                                        },
                                    },
                                ]}>
                                <Input
                                    placehoder={intl.get(
                                        'projectSpace.inputProjectName'
                                    )}
                                />
                            </Item>
                            <Item
                                initialValue={projectId}
                                hidden
                                name="projectId"></Item>
                            <Item
                                style={{
                                    margin: '0',
                                }}
                                name="remark"
                                label={intl.get('base.remark')}>
                                <Input.TextArea
                                    autoSize={{ minRows: 3, maxRows: 3 }}
                                />
                            </Item>
                            <Item></Item>
                        </Form>
                    </div>
                </BaseModal>
            </div>
        </Spin>
    );
}

export default ScheduleProgressTab;
